var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99714 22.5403C5.36379 20.6329 5.67612 18.6251 6.11745 16.6174C6.33473 15.5666 6.06993 15.1182 4.89529 15.1985C3.72065 15.2788 2.41022 15.2387 1.1609 15.1985C-0.0884262 15.1584 -0.31249 14.5293 0.407229 13.6325C3.95151 9.25552 7.53652 4.93211 11.108 0.622087C11.5086 0.133528 11.9703 -0.214486 12.6289 0.153605C13.2875 0.521697 13.1517 0.976793 13.0431 1.52558C12.6492 3.53336 12.3233 5.54113 11.8888 7.50875C11.6647 8.52602 11.9567 8.88742 13.0159 8.84727C14.0789 8.79372 15.1441 8.79372 16.2071 8.84727C16.8114 8.84727 17.6058 8.53272 17.9181 9.3559C18.2305 10.1791 17.5718 10.5271 17.2391 11.0157C15.8812 12.6888 14.5051 14.3597 13.111 16.0284C11.0695 18.4645 9.04386 20.8917 7.03408 23.3099C6.64027 23.7851 6.19893 24.1666 5.52674 23.9256C4.85455 23.6847 4.99714 23.1158 4.99714 22.5403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/startIcon.ebf6f4ac9bb5cfed8695cf709cf1649f.svg";
export { ForwardRef as ReactComponent };